// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingModal {
    constructor({ state, elements, root }) {
      if (
        !state ||
        !elements?.object ||
        !elements?.expandButton ||
        !root
      ) {
        throw new Error(
          "[EspacioLaserV2] Modal requiere state, elements y root."
        );
      }

      this.state = state;
      this.elements = elements;
      this.root = root;

      this.object = elements.object;
      this.expandButton = elements.expandButton;
      this.saveButton = elements.saveButton;

      this.preview =
        this.object.closest(".el-engraving-preview");

      this.canvas = this.object.parentElement;

      this.abortController = new AbortController();

      this.isOpen = false;
      this.snapshot = null;
      this.expansionRatio = 1;
      this.normalCanvasSize = null;

      this.placeholder = null;
      this.originalParent = null;
      this.originalNextSibling = null;

      this.bindEvents();
    }

    bindEvents() {
      const { signal } = this.abortController;

      this.expandButton.addEventListener(
        "click",
        () => this.open(),
        { signal }
      );

      this.saveButton?.addEventListener(
        "click",
        () => this.save(),
        { signal }
      );

      this.root
        .querySelectorAll("[data-engraving-close]")
        .forEach((button) => {
          button.addEventListener(
            "click",
            () => this.cancel(),
            { signal }
          );
        });

      document.addEventListener(
        "keydown",
        (event) => {
          if (
            event.key === "Escape" &&
            this.isOpen
          ) {
            this.cancel();
          }
        },
        { signal }
      );
    }

    open() {
      if (
        this.isOpen ||
        !this.preview ||
        !this.canvas
      ) {
        return;
      }

      this.snapshot = {
        x: this.state.transform.x,
        y: this.state.transform.y,
        rotation: this.state.transform.rotation,
        scale: this.state.transform.scale,
      };

      const normalRect =
        this.canvas.getBoundingClientRect();

      this.normalCanvasSize = {
        width: normalRect.width,
        height: normalRect.height,
      };

      /*
       * Guardamos el lugar original del personalizador.
       */
      this.originalParent =
        this.preview.parentNode;

      this.originalNextSibling =
        this.preview.nextSibling;

      this.placeholder =
        document.createComment(
          "espacio-laser-modal-placeholder"
        );

      this.originalParent.insertBefore(
        this.placeholder,
        this.preview
      );

      /*
       * Movemos el modal directamente al body.
       * Así escapa de las capas del tema Shopify.
       */
      document.body.appendChild(
        this.preview
      );

      this.preview.classList.add(
        "is-expanded"
      );

      document.body.classList.add(
        "engraving-modal-open"
      );

      this.isOpen = true;

      this.state.setUI(
        "expanded",
        true
      );

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.scaleToExpandedView();
        });
      });
    }

    scaleToExpandedView() {
      if (
        !this.isOpen ||
        !this.normalCanvasSize
      ) {
        return;
      }

      const expandedRect =
        this.canvas.getBoundingClientRect();

      const ratioX =
        expandedRect.width /
        this.normalCanvasSize.width;

      const ratioY =
        expandedRect.height /
        this.normalCanvasSize.height;

      const ratio = Math.min(
        ratioX,
        ratioY
      );

      this.expansionRatio =
        Number.isFinite(ratio) &&
        ratio > 0
          ? ratio
          : 1;

      this.state.setPosition(
        this.snapshot.x *
          this.expansionRatio,
        this.snapshot.y *
          this.expansionRatio
      );

      this.state.setScale(
        this.snapshot.scale *
          this.expansionRatio
      );
    }

    save() {
      if (!this.isOpen) return;

      const ratio =
        this.expansionRatio || 1;

      this.state.setPosition(
        this.state.transform.x / ratio,
        this.state.transform.y / ratio
      );

      this.state.setScale(
        this.state.transform.scale / ratio
      );

      this.close();
    }

    cancel() {
      if (!this.isOpen) return;

      this.state.setPosition(
        this.snapshot.x,
        this.snapshot.y
      );

      this.state.setRotation(
        this.snapshot.rotation
      );

      this.state.setScale(
        this.snapshot.scale
      );

      this.close();
    }

    close() {
      this.preview.classList.remove(
        "is-expanded"
      );

      document.body.classList.remove(
        "engraving-modal-open"
      );

      /*
       * Devolvemos el personalizador exactamente
       * al lugar que ocupaba en la página.
       */
      if (
        this.placeholder &&
        this.placeholder.parentNode
      ) {
        this.placeholder.parentNode.insertBefore(
          this.preview,
          this.placeholder
        );

        this.placeholder.remove();
      } else if (this.originalParent) {
        this.originalParent.insertBefore(
          this.preview,
          this.originalNextSibling
        );
      }

      this.state.setUI(
        "expanded",
        false
      );

      this.isOpen = false;
      this.snapshot = null;
      this.expansionRatio = 1;
      this.normalCanvasSize = null;
      this.placeholder = null;
      this.originalParent = null;
      this.originalNextSibling = null;
    }

    destroy() {
      if (this.isOpen) {
        this.cancel();
      }

      this.abortController.abort();
    }
  }

  EL.EngravingModal =
    EngravingModal;
})();